export default function Collider(
  x,
  y,
  w,
  h,
  canvasRef,
  mousePos,
  checkFunc,
  animation,
  triggeredFunction,
  duration,
  value,
) {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "rgba(0, 0, 0, 0)";
  ctx.fillRect(x, y, w, h);

  if (
    mousePos.x > x &&
    mousePos.y > y &&
    mousePos.x < x + w &&
    mousePos.y < y + h
  ) {
    if (animation === true) {
      let running = checkFunc(triggeredFunction, duration);
    } else {
      triggeredFunction(value);
    }
  }

  return null;
}
